class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLinks = document.querySelectorAll('.cart-icon-bubble, .mobile-cart-icon-bubble'); 
    if (!cartLinks.length) return;

    cartLinks.forEach(cartLink => {
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');

      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLink);
      });

      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });
    if (document.querySelector('.cart-drawer-upsell__slider')) {
      initializeSlickSlider('.cart-drawer-upsell__slider');
    }

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

function initializeSlickSlider(selector) {
  const $sliders = $(selector);

  if (!$sliders.length) return;

  $sliders.each(function () {
    const $slider = $(this);
    const $wrapper = $slider.closest('.cart-drawer-upsell__slider-wrapper');
    const $prev = $wrapper.find('.upsell-prev');
    const $next = $wrapper.find('.upsell-next');

    const slickOptions = {
      slidesToShow: 2.6,
      slidesToScroll: 1,
      infinite: false,
      dots: false,
      arrows: false,
      responsive: [
        {
          breakpoint: 768,
          settings: { slidesToShow: 2.6 },
        },
        {
          breakpoint: 480,
          settings: { slidesToShow: 2.6 },
        },
      ],
    };

    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('refresh');
    } else {
      $slider.slick(slickOptions);
    }

    const updateArrows = () => {
      if (!$slider.hasClass('slick-initialized')) return;
      const slickInstance = $slider.slick('getSlick');
      const currentSlide = $slider.slick('slickCurrentSlide');
      const slidesToShow = slickInstance.options.slidesToShow;
      const totalSlides = slickInstance.slideCount;
      const maxSlide = Math.max(totalSlides - slidesToShow, 0);

      if (currentSlide <= 0) {
        $prev.addClass('disabled');
      } else {
        $prev.removeClass('disabled');
      }

      if (currentSlide >= maxSlide) {
        $next.addClass('disabled');
      } else {
        $next.removeClass('disabled');
      }
    };

    const namespace = '.upsellNav';
    $slider.off('afterChange' + namespace).on('afterChange' + namespace, updateArrows);

    $prev
      .off('click' + namespace)
      .on('click' + namespace, function () {
        if (!$slider.hasClass('slick-initialized')) return;
        $slider.slick('slickPrev');
      });

    $next
      .off('click' + namespace)
      .on('click' + namespace, function () {
        if (!$slider.hasClass('slick-initialized')) return;
        $slider.slick('slickNext');
      });

    updateArrows();
  });
}